import { FOUNDATION } from "../../constants"

export const UPDATE_ERROR = `${FOUNDATION}_UPDATE_ERROR`

export const ERROR_OBJECTS = {
  404: {
    code: 404,
    title: "Oops!",
    message: "Page not found",
  },
  403: {
    code: 403,
    title: "Forbidden",
    message: "You don't have access to this page",
  },
  500: {
    code: 500,
    title: "Sorry, unexpected error!",
    message: "We are working on fixing the problem, please try again soon",
  },
}
